import { TeamsNewTicketPage } from "components/microsoftTeamsPages/NewTicketPage";
import { TeamsProfilePage } from "components/microsoftTeamsPages/userProfilePage";
import { Route, Routes } from "react-router";

export const MicrosoftTeamsRouter: FC = ({ children }) => (
  <Routes>
    <Route element={<TeamsNewTicketPage />} path="/microsoftTeams/newRequest" />
    <Route element={<TeamsProfilePage />} path="/microsoftTeams/profile" />
    <Route element={children} path="*" />
  </Routes>
);
